const state = {
  avatar: null
};
const actions = {
  avatar ({commit},data) {
    commit("avatarMutations", data)
  }
};
const mutations = {
  avatarMutations (state, data) {
    state.avatar = data;
  }
};
const getters = {
 
};
 
// 不要忘记把state, mutations等暴露出去。
export default {
  state,
  mutations,
  actions,
  getters
}